// This is a generated file. Don't edit.

export const PACKAGE_VERSION = '';
